import { useState, useEffect } from 'react';

/**
 * InstallPWA — shows an "Install app" button only when:
 * - The browser supports beforeinstallprompt (Chrome / Edge)
 * - The app is NOT already installed
 *
 * On iOS (Safari) the button is hidden; user must use Share → Add to Home Screen.
 */
export default function InstallPWA() {
  const [prompt, setPrompt] = useState(null);
  const [installed, setInstalled] = useState(false);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    window.addEventListener('appinstalled', () => {
      setInstalled(true);
      setPrompt(null);
    });
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  if (!prompt || installed) return null;

  const handleInstall = async () => {
    prompt.prompt();
    const { outcome } = await prompt.userChoice;
    if (outcome === 'accepted') {
      setInstalled(true);
      setPrompt(null);
    }
  };

  return (
    <button
      onClick={handleInstall}
      title="Install ZenAnalytics as an app"
      style={{
        background: 'rgba(56,189,248,0.10)',
        border: '1px solid rgba(56,189,248,0.30)',
        borderRadius: '8px',
        color: '#38bdf8',
        fontSize: '12px',
        fontWeight: '600',
        padding: '6px 12px',
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        whiteSpace: 'nowrap',
        flexShrink: 0,
        fontFamily: 'inherit',
        transition: 'background 0.15s, border-color 0.15s',
      }}
      onMouseEnter={e => {
        e.currentTarget.style.background = 'rgba(56,189,248,0.20)';
        e.currentTarget.style.borderColor = 'rgba(56,189,248,0.55)';
      }}
      onMouseLeave={e => {
        e.currentTarget.style.background = 'rgba(56,189,248,0.10)';
        e.currentTarget.style.borderColor = 'rgba(56,189,248,0.30)';
      }}
    >
      📲 Install app
    </button>
  );
}
